import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'ログ',
  
  // model
  serviceModel: [],
  serviceDeviceModel: [],

  // model : サービス運用者の場合のみ
  serviceInfoModel: {},
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 機能別ログ一覧を読出し
   */
  loadModel ({commit}, {serviceParams}) {
    return new Promise((resolve, reject) => {
      const isAdmin = this.getters['auth/isAdmin']

      const types = []
      const methods = []
      const parameters = []

      // システム管理者の場合
      if (isAdmin) {
        types.push('service')
        methods.push('v1ServiceListGet')
        parameters.push(serviceParams)

      // サービス運用者の場合
      } else {
        types.push('service')
        methods.push('v1ServiceDetailGet')
        parameters.push(serviceParams)
      }

      ApiManager.request(types, methods, parameters)
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            if (isAdmin) {
              commit('setServiceModel', res[0].data.serviceInfo)
              console.log('serviceModel', state.serviceModel)
            } else {
              commit('setServiceInfoModel', res[0].data.serviceBasicInfo)
              console.log('serviceInfoModel', state.serviceInfoModel)
            }
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * 機能別ログ一覧を読出し
   */
  loadServiceDeviceList ({commit}, {deviceParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['device'],
        ['v1DeviceListGet'],
        [deviceParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceDeviceModel', res[0].data.deviceTypes)
            console.log('serviceDeviceModel', state.serviceDeviceModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
  // model
  setServiceModel (state, data) {
    Vue.set(state, 'serviceModel', data)
  },
  setServiceDeviceModel (state, data) {
    Vue.set(state, 'serviceDeviceModel', data)
  },
  setServiceInfoModel (state, data) {
    Vue.set(state, 'serviceInfoModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
